<icz-cross-reference-table
  [esslEntity]="file"
  (crossReferenceCountChanged)="onCrossReferenceCountChanged()"
></icz-cross-reference-table>
